import {
  ModuleNavTemplate,
  ProgramNavTemplate,
} from '@efdigital/ll-addon-content';
import { EditContext } from '@efdigital/ll-admin-v2/components/edit-context.gts';
import { programTemplateParts } from '@efdigital/ll-admin-v2/components/parts.gts';
import ContentBreadcrumb from '@efdigital/ll-admin-v2/components/programs/content-breadcrumb.gts';
import { EditModuleContent } from '@efdigital/ll-admin-v2/components/programs/edit-module-content.gts';
import { EditModulePages } from '@efdigital/ll-admin-v2/components/programs/edit-module-pages.gts';
import { EditModuleQuizzes } from '@efdigital/ll-admin-v2/components/programs/edit-module-quizzes.gts';
import { Sidebar } from '@efdigital/ll-admin-v2/components/sidebar/sidebar.gts';
import type { ModelFrom } from '@efdigital/ll-admin-v2/lib/type-utils';
import type ProgramsProgramCohortContentModuleRoute from '@efdigital/ll-admin-v2/routes/programs/program/cohort/content/module';
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { pageTitle } from 'ember-page-title';

interface ContentIndexSignature {
  Args: {
    model: ModelFrom<ProgramsProgramCohortContentModuleRoute>;
    controller: unknown;
  };
}

const parts = programTemplateParts;

const Template: TemplateOnlyComponent<ContentIndexSignature> = <template>
  {{pageTitle "Module"}}

  <ContentBreadcrumb @model={{@model}} />

  <div class="mb-5">
    <EditContext as |context|>
      <Sidebar>
        <:content>
          <ProgramNavTemplate
            @program={{@model.program}}
            @cohort={{@model.cohort}}
            @parts={{parts}}
          />
          <ModuleNavTemplate
            @program={{@model.program}}
            @cohort={{@model.cohort}}
            @module={{@model.module}}
            @parts={{parts}}
          >
            <div class="alert alert-secondary p-5">
              <h1 class="display-6">This is the module editor.</h1>
              <ul class="lead mb-0">
                <li>Use the panel on the right to edit the module’s structure.</li>
                <li>Navigate to a page or quiz to view or edit its contents.</li>
                <li>Participants will start on the first page when accessing the
                  module.</li>
              </ul>
            </div>
          </ModuleNavTemplate>
        </:content>
        <:sidebar>
          <div class="px-3 py-4">
            <EditModuleContent
              @item={{@model.module}}
              @context={{context}}
              class="mb-5"
            />
            <EditModulePages
              @item={{@model.module}}
              @context={{context}}
              @params={{@model}}
              class="mb-5"
            />
            <EditModuleQuizzes
              @item={{@model.module}}
              @context={{context}}
              @params={{@model}}
              class="mb-5"
            />
          </div>
        </:sidebar>
      </Sidebar>
    </EditContext>
  </div>
</template>;

export default Template;
